export default function Smiler() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="100%"
      height="100%"
      viewBox="0 0 35 35"
      enableBackground="new 0 0 35 35"
      xmlSpace="preserve"
    >
      <g id="Layer_2_00000057838450109198858080000004550371571263971753_">
        <g id="Layer_1-2">
          <g id="Layer_2-2">
            <g id="Layer_1-2-2">
              <ellipse
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="1.47"
                strokeMiterlimit="14"
                cx="17.5"
                cy="17.5"
                rx="16.8"
                ry="15.4"
              />
              <circle cx="9" cy="15.9" r="2.5" />
              <circle cx="25.4" cy="15.9" r="2.5" />
              <path
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="1.47"
                strokeMiterlimit="14"
                d="M6.9,21.7c0,0,2.6,7.5,10.6,7.5
                      S28,21.7,28,21.7"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
